import React, { useRef } from "react";
import { Container } from "reactstrap";
import "../../../src/assets/css/home.css";

export default function ReelSection() {
    const reels = [
        "/assets/videos/feed3.mp4",
        "/assets/videos/feed2.mp4",
        "/assets/videos/feed1.mp4",
        "/assets/videos/feed4.mp4",
        "/assets/videos/feed6.mp4",
        "/assets/videos/feed5.mp4",
    ];

    const videoRefs = useRef([]);

    const handleMouseEnter = (index) => {
        videoRefs.current[index]?.play();
    };

    const handleMouseLeave = (index) => {
        videoRefs.current[index]?.pause();
        videoRefs.current[index].currentTime = 1; // reset to start
    };

    return (
        <div className="custom-width pb-5 mx-auto">
            <section className="reel-section mt-5 text-primary">
                <h1>Follow Us on Social Media</h1>
                <div className="row g-0">
                    {reels.map((video, index) => (
                        <div
                            key={index}
                            className="col-12 col-lg-4 col-md-6 col-sm-6 "
                            data-aos="fade-out"
                        >
                            <div
                                className="reel-video-wrapper position-relative overflow-hidden"
                                style={{
                                    width: "100%",
                                    height: "550px",
                                    maxHeight: "600px",
                                }}
                                onMouseEnter={() => handleMouseEnter(index)}
                                onMouseLeave={() => handleMouseLeave(index)}
                            >
                                <video
                                    ref={(el) => (videoRefs.current[index] = el)}
                                    src={video}
                                    muted
                                    playsInline
                                    style={{
                                        objectFit: "cover",
                                        display: "block",
                                        border: "1px solid #343333",
                                    }}
                                />
                            </div>
                        </div>
                    ))}
                </div>
            </section>
        </div>


    );
}
